import { render, staticRenderFns } from "./LmServiceLanguages.vue?vue&type=template&id=2568764f"
import script from "./LmServiceLanguages.vue?vue&type=script&lang=js"
export * from "./LmServiceLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports